module.exports = __webpack_public_path__ + "static/img/subNews1.73dc706.png";


//////////////////
// WEBPACK FOOTER
// ./src/daoba-match/assets/sportsLogo/subNews1.png
// module id = 3Ue6
// module chunks = 9